import React from 'react';
import { NewCandidateSelector } from 'features/new-candidate/components';
import usePageTitle from 'hooks/usePageTitle';
import { EntityRoutes } from 'routes/constants';
import { PageTitles } from 'UI/constants/defaults';

import { getQueryParams } from './NewCandidatePage.utils';

export const NewCandidatePage = ({ location, history }) => {
  usePageTitle({ title: PageTitles.CandidateCreate });

  const queryParams = getQueryParams(location);

  const handleReset = () => {
    history.replace(EntityRoutes.CandidateCreate);
  };

  return (
    <NewCandidateSelector key={location?.search} onReset={handleReset} queryParams={queryParams} />
  );
};
